import colors from 'styles/themes/colors';
import { defaultColors as entityDefaultColors } from 'context/entityContext';

const getColorSourceOfStreams = (breakdown: string): string => {
  // lowercase - default, Capitalized - Spotify
  switch (breakdown) {
    case 'playlist':
    case 'Others Playlist':
      return entityDefaultColors.seriesColors[0];
    case 'library':
    case 'Collection':
      return entityDefaultColors.seriesColors[1];
    case 'search':
    case 'Album':
      return entityDefaultColors.seriesColors[2];
    case 'flow':
    case 'Play Queue':
      return entityDefaultColors.seriesColors[3];
    case 'charts':
    case 'Charts':
      return entityDefaultColors.seriesColors[4];
    case 'radio':
    case 'Radio':
      return entityDefaultColors.seriesColors[5];
    case 'other':
    case 'Artist':
      return entityDefaultColors.seriesColors[6];
    case 'Search':
      return entityDefaultColors.seriesColors[7];
    case 'Other':
      return colors.Lime;
    default:
      return colors.Grey;
  }
};

export default getColorSourceOfStreams;
